import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appTextOnly]'
})
export class TextOnlyDirective {

  private regex: RegExp = new RegExp(/^[a-zA-Z\s]*$/);

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!this.regex.test(inputChar)) {
      event.preventDefault(); // block non-text characters
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');

    if (!this.regex.test(pastedText)) {
      event.preventDefault(); // block invalid paste
    }
  }
}
